import { render, staticRenderFns } from "./BaseInputFilearea.vue?vue&type=template&id=405f24bc&"
import script from "./BaseInputFilearea.vue?vue&type=script&lang=js&"
export * from "./BaseInputFilearea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('405f24bc')) {
      api.createRecord('405f24bc', component.options)
    } else {
      api.reload('405f24bc', component.options)
    }
    module.hot.accept("./BaseInputFilearea.vue?vue&type=template&id=405f24bc&", function () {
      api.rerender('405f24bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseInputFilearea.vue"
export default component.exports